import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription, filter } from 'rxjs';
import * as HelpActions from 'src/app/store/help/help.actions';
import { selectRowModify, selectRows } from 'src/app/store/help/help.selector';
import { RowDataDb } from 'src/app/model/help';

@Component({
  templateUrl: './helper-order-row.dialog.component.html',
})
export class HelperOrderRowDialogComponent  implements OnInit, OnDestroy {
    rows: RowDataDb[];

    rows$: Observable<RowDataDb[] | undefined>;
    rowsSub: Subscription | undefined;
    rowModify$: Observable<boolean | undefined>;
    rowModifySub: Subscription | undefined;

    subsectionId: number;

    // design
    screenWidth: number;
    MIN_MD_WIDTH = 500;
    MAX_MD_WIDTH = 1120;
    MIN_WIDTH_COL4 = 1680;
    DELTA_ERROR_PIXEL = 7;
    MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

    constructor(
        private store: Store<AppState>,
        private ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
    ){
        if (config.data !== undefined && config.data.subsectionId !== undefined) {
            this.subsectionId = config.data.subsectionId;
        }
        this.initSelectors();
    }


    // Design
    @HostListener('window:resize', ['$event'])
    onResize() {
      this.screenWidth = window.innerWidth;
    }

    ngOnInit(): void {
        if (this.subsectionId){
            this.store.dispatch(HelpActions.getHelpRows({subsectionId:this.subsectionId}));
        }
        this.subscribeAll();
    }

    initSelectors(): void{
        this.rowModify$ = this.store.select(selectRowModify);
        this.rows$ = this.store.select(selectRows);
    }


    subscribeAll(): void {
        this.rowsSub = this.rows$?.subscribe((rows) => {
            this.rows = rows;
        });
        this.rowModifySub = this.rowModify$?.pipe(filter(rowModify => !!rowModify))
        .subscribe(() => {
            if (this.subsectionId){
                this.store.dispatch(HelpActions.getHelpRows({subsectionId:this.subsectionId}));
            }
        });
    }

    ngOnDestroy(): void {
        this.rowsSub?.unsubscribe();
        this.rowModifySub?.unsubscribe();
    }

    saveOrder(): void{
    }

    closeDialog(): void{
        this.ref.close();
    }

    dynamicButtonWidth() : string {
        return (this.screenWidth <= this.MIN_TWO_BUTTONS_DIALOG_WIDTH) ? "w-full" : "w-16rem";
    }

    rowReorder(event) {
        this.rows[event.dropIndex].Order = event.dropIndex;
        this.store.dispatch(HelpActions.editHelpRow({ row : this.rows[event.dropIndex] }));
    }
}
